<template>
  <div class="funcBlock" :style="{width: activeWidth}">
    <p :class="{tit: true, 'tit-border':!isChartShow}">
      {{tit}}
      <slot name="blockTit"></slot>
    </p>
    <div :class="{content: true, 'border-style':showBorder, 'chart-border':!isChartShow}">
      <slot name="blockCon"></slot>
    </div>
  </div>
</template>

<script>
/**
 * @param tit：标题文案
 * 调用示例: <comTitle tit_txt='标题'></comTitle>
 */
export default {
  name: 'funcBlock',
  props: {
    tit: String,
    activeWidth: String,
    showBorder: Boolean,
    isChartShow: Boolean
  }
};
</script>

<style lang="less" scoped>
  .funcBlock {
    position: relative;
    margin-bottom: 20px;
    .tit{
      background: #fff;
      height: 50px;
      line-height: 50px;
      padding-left: 10px;
      font-weight: bold;
      border: 1px solid #80808036;
      border-bottom: 0;
    }
    .tit-border{
      border: 1px solid #80808036;
    }
    .content{
      border-radius: 2px;
      i{
        color: #409eff;
      }
      .rateSet{
        margin-bottom: 30px;
      }
      .bottom{
        margin-top: 20px;
      }
    }
    .border-style{
      border: 1px solid #80808036;
    }
    .chart-border{
      border: 0
    }
  }
</style>
